import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchDropdownByTitle } from '../../service/DropdownService';
import { SearchIcon } from 'lucide-react';

const Search = ({ initialSpecialist = "", initialType = "medical" }) => {
    const [selectedType, setSelectedType] = useState(initialType);
    const [specialist, setSpecialist] = useState(initialSpecialist);
    const [selectingId,setSelectingId] = useState(null);
    const [suggestion, setSuggestion] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [highlightIndex, setHighLightIndex] = useState(-1);
    const navigate = useNavigate();

    useEffect(() => {
        setSpecialist(initialSpecialist);
        setSelectedType(initialType);
    }, [initialSpecialist, initialType]);

    useEffect(() => {
        if (!specialist) {
            setSuggestion([]);
            setHighLightIndex(-1);
            return;
        }
        fetchData();
    }, [specialist])


    const fetchData = async () => {
        try {

            const data = await fetchDropdownByTitle(specialist);
            setSuggestion(data || []);

            if (data && data.length > 0) {
                setHighLightIndex(0);
            } else {
                setHighLightIndex(-1);
            }

        } catch (error) {
            console.error("Error fetching", error);

        }
    }
    const handleSelect = (item) => {
        setSpecialist(item.title);
        setSelectingId(item.id);
        setShowSuggestions(false);
        setHighLightIndex(-1);
    }

    const handleSearch = (e) => {
        e.preventDefault();
        navigate('/results', {
            state: { specialist, selectedType,selectingId }
        });
    };

    const handleKeyDown = (e) => {
        if (!showSuggestions) return;

        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighLightIndex((prev) => prev < suggestion.length - 1 ? prev + 1 : 0)
        }

        if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighLightIndex((prev) => prev > 0 ? prev - 1 : suggestion.length - 1)
        }
        if (e.key === "Enter") {
            if (highlightIndex >= 0 && suggestion[highlightIndex]) {
                e.preventDefault();
                handleSelect(suggestion[highlightIndex])
            }
        }
    }

    return (
        <div className="search-main-wrapper float_left" >
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="sb-health-main-sec">
                            <div className="container">
                                <form className="search-bar " onSubmit={handleSearch} style={{ marginBottom: 0, borderRadius: '20px' }}>
                                    <div style={{ position: 'relative', width: '100%' }}>
                                        <input
                                            style={{ position: 'relative', width: '100%', borderRadius: '20px' }}
                                            type="text"
                                            placeholder="Search for your needs"
                                            value={specialist}
                                            onChange={(e) => {
                                                setSpecialist(e.target.value);
                                                setShowSuggestions(true);
                                                if (suggestion.length > 0) {
                                                    setHighLightIndex(0);
                                                }
                                            }}
                                            onFocus={() => setShowSuggestions(true)}
                                            onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
                                            onKeyDown={handleKeyDown}
                                            autoComplete="off"
                                        />
                                        {showSuggestions && specialist && (
                                            <ul className="suggestion-list"style={{position:'absolute',borderRadius:'10px'}}>
                                                {suggestion.length > 0 ? (
                                                    suggestion.map((item, index) => {
                                                        return (
                                                            <li key={index}
                                                                onMouseDown={() => handleSelect(item)}
                                                                className={index === highlightIndex ? "highlight" : ''}
                                                                style={{
                                                                    background: index === highlightIndex ? "#e6f0ff" : "",
                                                                    padding: "8px",
                                                                    cursor: "pointer"
                                                                }}>
                                                                {item.title}

                                                            </li>
                                                        )
                                                    })
                                                ) : (
                                                    <li>No Match Found</li>
                                                )}
                                            </ul>
                                        )}
                                    </div>
                                    <button type="submit" style={{ borderRadius: '0px 16px 16px 0px', background: '#004274' }}><SearchIcon size={29} /></button>
                                </form>
                                {/* )} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Search;
